import axios from 'axios'

const API = axios.create({ baseURL: global.config.API_URL})
//const API = axios.create({ baseURL: process.env.REACT_APP_API})

API.interceptors.request.use((req) => {
    if(localStorage.getItem('profile')) {
        req.headers.authorization = `Bearer ${JSON.parse(localStorage.getItem('profile')).token}`
    }

    return req
})

// export const fetchInvoices =() => API.get('/invoices')
export const fetchInvoice =(id) => API.get(`/invoice?id=${id}`)
export const addInvoice =( invoice ) => API.post('/invoice', invoice)
export const updateInvoice = (updatedInvoice) => API.patch(`/invoice/Edit`, updatedInvoice)
export const deleteInvoice =(id) => API.delete(`/invoice/${id}`)
export const fetchInvoicesByUser = (searchQuery) => API.get(`/invoice`);
export const fetchInvoiceStatusCurrentYearMonths = () => API.get(`/invoice/statusCurrentYearMonths`);
export const salesReport = (startDate, endDate) => API.get(`/invoice/salesReport?startDate=${startDate}&endDate=${endDate}`);


export const fetchInventory =(id) => API.get(`/inventory/?id=${id}`)
export const addInventory =( inventory ) => API.post('/inventory', inventory)
export const updateInventory = (id, updatedInventory) => API.patch(`/inventory/edit`, updatedInventory)
export const deleteInventory =(id) => API.patch(`/inventory/delete/${id}`)
export const fetchInventoriesByUser = (searchQuery) => API.get(`/inventory?searchQuery=${searchQuery}`);
export const fetchInventoryStatus = () => API.get(`/inventory/status`);
export const inventoryReport = (startDate, endDate) => API.get(`/inventory/inventoryReport?startDate=${startDate}&endDate=${endDate}`);

export const fetchClient = (id) => API.get(`/customer/${id}`);
export const fetchClients = (page) => API.get(`/customer?page=${page}`);
export const addClient =( client ) => API.post('/customer', client);
export const updateClient = (id, updatedClient) => API.patch(`/customer/edit`, updatedClient)
export const deleteClient =(id) => API.delete(`/customer/${id}`)
export const fetchClientsByUser = (searchQuery) => API.get(`/customer/user?searchQuery=${searchQuery}`);
export const customerReport = (startDate, endDate,customerName) => API.get(`/customer/customerReport?startDate=${startDate}&endDate=${endDate}&customerName=${customerName}`);


export const fetchVendor = (id) => API.get(`/vendor/${id}`);
export const fetchVendors = (page) => API.get(`/vendor?page=${page}`);
export const addVendor =( vendor ) => API.post('/vendor', vendor);
export const updateVendor = (id, updatedVendor) => API.patch(`/vendor/edit`, updatedVendor)
export const deleteVendor =(id) => API.delete(`/vendor/${id}`)
export const fetchVendorsByUser = (searchQuery) => API.get(`/vendor/user?searchQuery=${searchQuery.search}`);
export const vendorReport = (startDate, endDate, vendorName) => API.get(`/vendor/vendorReport?startDate=${startDate}&endDate=${endDate}&vendorName=${vendorName}`);



export const signIn =(formData)=> API.post('/users/signin', formData)
export const signUp =(formData)=> API.post('/users/signup', formData)
export const forgot = (formData) => API.post('/users/forgot', formData);
export const reset = (formData) => API.post('/users/reset', formData);



export const fetchUser = (id) => API.get(`/users/${id}`);
export const addUser =( user ) => API.post('/users', user);
export const updateUser = (id, updatedUser) => API.patch(`/users/edit`, updatedUser)
export const deleteUser =(id) => API.patch(`/users/delete/${id}`)
export const fetchAllUser = () => API.get(`/users`);

export const fetchMetal = (id) => API.get(`/metal/${id}`);
export const fetchMetals = (page) => API.get(`/metal?page=${page}`);
export const addMetal =( metal ) => API.post('/metal', metal);
export const updateMetal = (id, updatedMetal) => API.patch(`/metal/edit`, updatedMetal)
export const deleteMetal =(id) => API.patch(`/metal/delete/${id}`)
export const fetchMetalsByUser = (searchQuery) => API.get(`/metal/user?searchQuery=${searchQuery.search}`);

export const fetchShipping = (id) => API.get(`/shipping/${id}`);
export const fetchShippings = () => API.get(`/shipping`);
export const addShipping =( shipping ) => API.post('/shipping', shipping);
export const updateShipping = (id, updatedShipping) => API.patch(`/shipping/edit`, updatedShipping)
export const deleteShipping =(id) => API.patch(`/shipping/delete/${id}`)
export const fetchShippingsByUser = (searchQuery) => API.get(`/shipping/user?searchQuery=${searchQuery.search}`);